import {EmbeddingType} from 'common/src/modules/ragSearch/ragSearch.enums';
import {generalKnowledgeToolSchema} from 'common/src/modules/shared/copilot/copilot.schemas';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import invokeRagArticleSearch from 'common/src/modules/shared/copilot/utils/invokeRagArticleSearch';
import {AnalyticsToolName} from '../copilotAnalytics.enums';

function getBestPracticesTool() {
  async function execute({
    input: {prompt},
    toolUtils,
    callChain,
  }: ToolExecuteParams<typeof generalKnowledgeToolSchema>): Promise<ToolResult> {
    const result = await invokeRagArticleSearch({
      prompt,
      embeddingTypes: [EmbeddingType.AnalyticsAndInsights],
      toolUtils,
      callChain,
    });

    return result;
  }

  return tool({
    name: AnalyticsToolName.GetBestPractices,
    displayName: 'Searching best practices',
    description:
      'Provides best practices related to campaign performance, both informational (guidelines) and prescriptive (actionable recommendations).',
    execute,
    inputSchema: generalKnowledgeToolSchema,
  });
}

export default getBestPracticesTool;
